<div class="layout">
    <div class="layout__content"></div>
</div>
 